<template>
  <div class="flex w-full flex-wrap sm:flex-nowrap sm:space-x-4">
    <div class="w-full sm:w-1/2">
      <FirstNameField
        :label="$t('field.first-name.label') + labelSuffix"
        placeholder=""
        v-on="$listeners"
      />
    </div>

    <div class="w-full sm:w-1/2 mt-4 sm:mt-0">
      <LastNameField
        :label="$t('field.last-name.label') + labelSuffix"
        placeholder=""
        v-on="$listeners"
      />
    </div>
  </div>
</template>

<script>
import FirstNameField from 'chimera/all/components/form/fields/firstName/FirstNameField'
import LastNameField from 'chimera/all/components/form/fields/lastName/LastNameField'

export default {
  name: 'SplitNameFormPart',

  components: {
    FirstNameField,
    LastNameField,
  },

  props: {
    /**
     * @type {string}
     */
    labelSuffix: {
      type: String,
      default: '',
    },
  },

  computed: {
    /**
     * @returns {string}
     */
    firstName() {
      return this.$store.getters['lead/getData']('first-name', '')
    },

    /**
     * @returns {string}
     */
    lastName() {
      return this.$store.getters['lead/getData']('last-name', '')
    },
  },

  watch: {
    firstName: 'setName',
    lastName: 'setName',
  },

  /**
   */
  mounted() {
    this.setName()
  },

  methods: {
    /**
     *
     */
    setName() {
      const name = `${this.firstName} ${this.lastName}`.trim()
      if (name) {
        this.$store.dispatch('lead/add', {
          key: 'name',
          value: name,
        })
      }

      this.$store.dispatch('lead/add', {
        key: 'custom-dimension-2',
        value: `${this.firstName}|${this.lastName}`.trim(),
      })
    },
  },
}
</script>
